import type {
  BusinessHours,
  DefaultRoles,
  ServiceCatalog,
} from '../tenant-config.js';

export const petServicesServiceCatalog: ServiceCatalog = [
  {
    slug: 'daycare',
    displayName: 'Day Care',
    priceCents: 4500,
    durationMinutes: 600,
    applicableStaffRoles: ['receptionist'],
    bookingRules: {
      minLeadTimeMinutes: 0,
      maxAdvanceDays: 90,
      allowMultiDay: false,
      requiresVaccinationCheck: true,
    },
    active: true,
  },
  {
    slug: 'boarding',
    displayName: 'Overnight Stay',
    priceCents: 7500,
    durationMinutes: 1440,
    applicableStaffRoles: ['receptionist'],
    bookingRules: {
      minLeadTimeMinutes: 60,
      maxAdvanceDays: 180,
      allowMultiDay: true,
      requiresVaccinationCheck: true,
    },
    active: true,
  },
  {
    slug: 'grooming',
    displayName: 'Grooming',
    priceCents: 6500,
    durationMinutes: 90,
    applicableStaffRoles: ['groomer'],
    bookingRules: {
      minLeadTimeMinutes: 120,
      maxAdvanceDays: 60,
      allowMultiDay: false,
      requiresVaccinationCheck: true,
    },
    active: true,
  },
];

export const petServicesDefaultRoles: DefaultRoles = [
  {
    slug: 'owner',
    displayName: 'Owner',
    seededAtProvisioning: true,
    assignedAtProvisioning: true,
  },
  {
    slug: 'manager',
    displayName: 'General Manager',
    seededAtProvisioning: true,
    assignedAtProvisioning: false,
  },
  {
    slug: 'receptionist',
    displayName: 'Receptionist',
    seededAtProvisioning: true,
    assignedAtProvisioning: false,
  },
  {
    slug: 'groomer',
    displayName: 'Groomer',
    seededAtProvisioning: true,
    assignedAtProvisioning: false,
  },
  {
    slug: 'walker',
    displayName: 'Walker',
    seededAtProvisioning: true,
    assignedAtProvisioning: false,
  },
];

export const petServicesBusinessHours: BusinessHours = {
  schedule: {
    '1': [{ open: '07:00', close: '19:00' }],
    '2': [{ open: '07:00', close: '19:00' }],
    '3': [{ open: '07:00', close: '19:00' }],
    '4': [{ open: '07:00', close: '19:00' }],
    '5': [{ open: '07:00', close: '19:00' }],
    '6': [{ open: '08:00', close: '17:00' }],
    '7': [{ open: '08:00', close: '17:00' }],
  },
  holidays: [],
};
